<template>
    <div>
        <BasePopup closeType="stayOnPage" width="700" @clickToClose="clickToClose" :displayGrid="'display:grid;'">
            <div>        
                <header>
                    <font-awesome-icon icon="fa-solid fa-location-arrow" style="color: #28bc6d;"/>
                    <span v-if="route.name == 'storeTrackersEdit'" class="ms-2 align-middle">Editar Rastreador</span>
                    <span v-else class="ms-2 align-middle">Novo Rastreador</span>
                </header>
                <div>
                    <form @submit.prevent="">
                        <div class="row">
                            <BaseSelect
                                class="col-12 mb-3"
                                id="type"
                                :items="trackerTypes"
                                label="Tipo *"
                                :required="false"
                                v-model="tracker.type"
                                :page="route.name"
                            />
                            <BaseSelect
                                v-if="tracker.type == 'pixel'"
                                class="col-12 mb-3"
                                id="content.tracking_type"
                                :items="pixelType"
                                label="Tipo de rastreio *"
                                :required="false"
                                v-model="tracker.content.tracking_type"
                                :page="route.name"
                            />
                            <BaseInput
                                class="col-12 mb-3"
                                label="Descrição *"
                                id="title"
                                :required="false"
                                v-model="tracker.title"
                                :page="route.name"
                            />
                            <BaseInput
                                class="col-12 mb-3"
                                label="ID *"
                                id="content.code"
                                :required="false"
                                v-model="tracker.content.code"
                                :page="route.name"
                            />
                            <div v-if="tracker.type == 'pixel' && tracker.content.tracking_type == 'api'">
                                <BaseInput
                                    class="col-12 mb-3"
                                    label="Token de acesso"
                                    id="content.access_token"
                                    :required="false"
                                    v-model="tracker.content.access_token"
                                    :page="route.name"
                                />
                                <BaseInput
                                    class="col-12 mb-3"
                                    label="Código de teste"
                                    id="testoken"
                                    :required="false"
                                    v-model="tracker.content.test_code"
                                    :page="route.name"
                                />
                            </div>
                            <BaseInput 
                                v-if="tracker.type == 'google_ads'"
                                class="col-12 mb-3"
                                id="content.label"
                                label="Rótulo de conversão"
                                :required="false"
                                v-model="tracker.content.label"
                            />
                            <BaseInput 
                                v-if="tracker.type == 'pixel' && tracker.tracking_type == 'code'"
                                class="col-12 mb-3"
                                id="content.domain"
                                label="Domínio"
                                placeholder="pixel.seudominio.com.br"
                                :required="false"
                                v-model="tracker.content.domain"
                            />
                            <BaseSelect
                                class="col-12 mb-3"
                                id="content.track_in"
                                :items="trackerActions"
                                label="Executar em *"
                                :required="false"
                                v-model="tracker.content.track_in"
                                :page="route.name"
                            />
                            <div v-if="tracker.type == 'google_ads' || tracker.type == 'outbrain'">
                                <label>Executar conversão nas formas de pagamento</label>
                                <BaseSwitch
                                    v-model:checked="tracker.content.track_boleto"  
                                    label="Boleto gerado"
                                    id="boleto"
                                    class="mb-3"
                                    :page="route.name" 
                                />
                                <BaseSwitch
                                    v-model:checked="tracker.content.track_pix" 
                                    label="Pix gerado"
                                    id="pix"
                                    class="mb-3"
                                    :page="route.name" 
                                />
                                <BaseSwitch
                                    v-model:checked="tracker.content.track_credit_card"
                                    label="Cartão de crédito"
                                    id="credit_card"
                                    class="mb-3"
                                    :page="route.name"
                                />
                            </div>
                            <div v-if="tracker.type == 'pixel' && tracker.content.tracking_type">
                                <label>Executar conversão nas formas de pagamento</label>
                                <BaseSwitch
                                    v-model:checked="tracker.content.track_boleto"  
                                    label="Boleto gerado"
                                    id="boleto"
                                    class="mb-3"
                                    :page="route.name" 
                                />
                                <BaseSwitch
                                    v-if="tracker.content.tracking_type == 'api'"
                                    v-model:checked="tracker.content.track_boleto_paid"  
                                    label="Boleto pago"
                                    id="boletopaid"
                                    class="mb-3"
                                    :page="route.name" 
                                />
                                <BaseSwitch
                                    v-model:checked="tracker.content.track_pix" 
                                    label="Pix gerado"
                                    id="pix"
                                    class="mb-3"
                                    :page="route.name" 
                                />
                                <BaseSwitch
                                    v-model:checked="tracker.content.track_pix_paid" 
                                    label="Pix pago"
                                    id="pixpaid"
                                    class="mb-3"
                                    :page="route.name" 
                                />
                                <BaseSwitch
                                    v-model:checked="tracker.content.track_credit_card"
                                    label="Cartão de crédito"
                                    id="credit_card"
                                    class="mb-3"
                                    :page="route.name"
                                />
                            </div>
                        </div>
                        <BaseButton @click="submit" class="mt-4 btn-success w-100">
                            Salvar
                        </BaseButton>
                    </form>
                </div>
            </div>
        </BasePopup>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, computed } from 'vue'
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router'
import { useGlobalStore } from '@/stores/global';
import { useStoreStore } from '@/stores/store';

const route = useRoute();
const router = useRouter();

const store_id = computed (function () {
    return route.params.id;
});

const storeStore = useStoreStore();
const { tracker } = storeToRefs(storeStore);

const globalStore = useGlobalStore();

const isLoaded = ref(false)

const trackerTypes = ref({
    'google_analytics': 'Google Analytics',
    'google_tag_manager': 'Google Tag Manager',
    'google_ads': 'Google ADS',
    'pixel': 'Facebook Pixel',
    'taboola': 'Taboola',
    'outbrain': 'Outbrain',
    'tiktok': 'TikTok',
    'microsoft_clarity': 'Microsoft Clarity',
})

const trackerActions = ref({
   'all': 'Todas as páginas',
   'checkout': 'Somente na página de checkout',
   'order': 'Somente na página de obrigado',
})

const pixelType = ref({
    'api' : 'API',
    'code' : 'Código',
})

onBeforeMount(() =>{
    globalStore.loader('show')
    delete globalStore.errors[route.name];
    
    if(route.name == 'storeTrackersEdit'){
        if(storeStore.tracker.id){
            globalStore.loader('hide')
            isLoaded.value = true;
        } else {
            storeStore.tryTracker(route.params.slug, store_id.value).then(() =>{
                globalStore.loader('hide')
                isLoaded.value = true;
            })
        }
    } else if(route.name == 'storeTrackersCreate'){
        globalStore.cleanObject(storeStore.tracker);
        globalStore.loader('hide')
        isLoaded.value = true
    }
})

let previousPage = router.options.history.state.back;

function clickToClose() {
    router.push(previousPage)
}

async function submit() {
    globalStore.loader('show')

    if(route.name == 'storeTrackersEdit'){

        let params = ['type', 'content', 'title'];

        globalStore.loader('show');
        storeStore.tryUpdateTracker(params, route.name).then(function(success) {
            globalStore.loader('hide');

            if(success){
                storeStore.tryTrackers(store_id.value);
                router.push('/stores/' + store_id.value + '/trackers')
            }
        })
    }
    else if(route.name == 'storeTrackersCreate'){
        let params = ['type', 'content', 'title'];

        globalStore.loader('show');
        storeStore.tryCreateTracker(params, route.name).then(function(success) {
            globalStore.loader('hide');

            if(success){
                storeStore.tryTrackers(store_id.value);
                router.push('/stores/' + store_id.value + '/trackers')
            }
        })
    }
}   
</script>